
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "vehicule-model.icon",
  "use": "vehicule-model.icon-usage",
  "viewBox": "0 0 38 35",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 35\" id=\"vehicule-model.icon\"><path d=\"M33.4 24.3v-5.7c0-.6-.1-1.2-.3-1.7L30 8.8c-.6-1.4-1.9-2.4-3.4-2.4H12.1c-1.5 0-2.9.9-3.4 2.4l-3.1 8.1c-.2.6-.3 1.1-.3 1.7v5.7c0 .7.6 1.2 1.2 1.2h25.8c.6 0 1.1-.5 1.1-1.2z\" /><path d=\"M5.2 24.3v3.1c0 .7.6 1.2 1.2 1.2h1.8c.7 0 1.2-.6 1.2-1.2v-1.8M33.4 24.3v3.1c0 .7-.6 1.2-1.2 1.2h-1.8c-.7 0-1.2-.6-1.2-1.2v-1.8M6.4 15.1l.9.3c.6.2 1.3.3 2 .3h20.2c.7 0 1.3-.1 2-.3l.9-.3M11.3 21.2H8.9c-1 0-1.8-.8-1.8-1.8 0-.4.2-.6.6-.6h2.5c1 0 1.8.8 1.8 1.8-.1.4-.3.6-.7.6zM24.2 23.1h-9.8M29.8 21.2h-2.5c-.4 0-.6-.2-.6-.6 0-1 .8-1.8 1.8-1.8H31c.4 0 .6.2.6.6 0 1-.8 1.8-1.8 1.8zM5.8 14.5H3.6c-.9 0-1.5-.7-1.5-1.5 0-.5.4-1 .9-1h1.8c.5 0 .9.4.9.9v1.6zM32.8 14.5H35c.9 0 1.5-.7 1.5-1.5 0-.5-.4-.9-.9-.9h-1.8c-.5 0-.9.4-.9.9v1.5z\" /></symbol>"
});
    sprite.add(symbol);
    export default class VehiculeModelIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="vehicule-model.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/vehicule-model.icon.svg